export default __webpack_public_path__ + "static/media/riya.da98278e.png";